const FIVE_MINUTES_MS = 5 * 60 * 1000

/**
 * Shared by the renewal route loader's prefetch and `BackofficePartnerRenewalPage`. Both need `gcTime`: the global
 * client runs `gcTime: 0`, which evicts an observer-less prefetch before the page mounts.
 */
export const PARTNER_RENEWAL_DETAILS_QUERY_OPTIONS = { gcTime: FIVE_MINUTES_MS }
